import moment from 'moment';

export const stringUtils = {
    toInputUppercase,
    toInputLowercase,
    phoneMask,
    cnpjMask,
    formatDateYYMMDD,
    formatCpf,
    formatCnpj,
    formatCep,
    formatData,
    formatDataYY,
    formatDataHora,
    formatDiaSemana,
    calculaIdade,
    aniversarioHoje,
    serialize,
    formataTelefone,
    formataValor,
    onlyNumbers,
    removeDiacritics,
    primeiroUltimoNome,
    capitalize,
    paramsToObject,
    validaCNPJ,
    validaCPF
};

function toInputUppercase(e) {
    var start = e.target.selectionStart;
    var end = e.target.selectionEnd;
    e.target.value = e.target.value.toUpperCase();
    e.target.setSelectionRange(start, end);
};

function toInputLowercase(e) {
    var start = e.target.selectionStart;
    var end = e.target.selectionEnd;
    e.target.value = e.target.value.toLowerCase();
    e.target.setSelectionRange(start, end);
};

function formataTelefone (v) {
    const digitos = !v ? '' : v.replace(/[^\d]/g, '');
    if (!digitos || digitos.length < 10) return v;
    const corte = digitos.length === 10 ? 6 : 7;
    const max = digitos.length > 11 ? 11 : digitos.length;
    return `(${digitos.substring(0, 2)}) ${digitos.substring(2, corte)}-${digitos.substring(corte, max)}`;
};

function primeiroUltimoNome(nome) {
    var spaceCount = (nome.split(" ").length - 1);
    var newText = nome;

    var array = nome.split(' ');
    if (spaceCount >= 2) {
        newText = array[0] + ' ' + array[array.length - 1];
    }

    return newText;
};

function phoneMask(v) {
    if (!v || v.length === 0) return '';
    const a = formataTelefone(v);
    return (a.length >= 6 && a[5] === '9') ? '(99) 99999-9999' : '(99) 9999-9999';
};

function formatDateYYMMDD(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
};

export function formatCpf(cpf) {
    cpf = cpf.replace(/[^\d]/g, "");
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}

function cnpjMask(v) {
    if (v !== null && v !== undefined) {
        return v
            .replace(/\D/g, '')
            .replace(/(\d{2})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1/$2')
            .replace(/(\d{4})(\d)/, '$1-$2')
            .replace(/(-\d{2})\d+?$/, '')
    }
}

export function formatCnpj(cnpj) {
    cnpj = cnpj.replace(/[^\d]/g, "");
    return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}

function formatCep(cep) {
    return cep.replace(/(\d{5})(\d{3})/, "$1-$2");
}

function formatData(data) {
    var newDate = moment(data);
    var dataString = newDate.format('DD') + '/' + newDate.format('MM') + '/' + newDate.format('YYYY');
    return dataString;
}

function formatDataYY(data) {
    var newDate = moment(data);
    var dataString = newDate.format('YYYY');
    return dataString;
}

function formatDataHora(data) {
    var newDate = moment(data);
    var dataString = newDate.format('DD/MM/YYYY HH:mm');
    return dataString;
}

function formatDiaSemana(dia) {
    switch (dia) {
        case 1:
            return 'Segunda-Feira';
        case 2:
            return 'Terça-Feira';
        case 3:
            return 'Quarta-Feira';
        case 4:
            return 'Quinta-Feira';
        case 5:
            return 'Sexta-Feira';
        case 6:
            return 'Sábado';
        default:
            return '--';
    }
}

function formataValor(valor) {
    var newValue = valor.toLocaleString(undefined, { maximumFractionDigits: 2 });
    return newValue;
}

function calculaIdade(dob1){
    var today = new Date();
    var birthDate = new Date(dob1);  // create a date object directly from `dob1` argument
    var age_now = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age_now--;
    }
    //console.log(age_now);
    return age_now;
}

function aniversarioHoje(dob1) {
    var date = moment(dob1);
    var now = moment();
    if (date.format('DD') === now.format('DD') && date.format('MM') === now.format('MM')) {
        return true;
    } else {
        return false;
    }
}

function serialize(obj) {
    let str = '?' + Object.keys(obj).reduce(function (a, k) {
        a.push(k + '=' + encodeURIComponent(obj[k]));
        return a;
    }, []).join('&');
    return str;
}

function onlyNumbers(str) {
    return str.replace(/\D/g, "");
};

function removeDiacritics(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

function capitalize(str) {
    return str.slice(0, 1).toUpperCase() + str.toLowerCase().slice(1, str.length)
};

function paramsToObject(search) {
    return JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) { return key === "" ? value : decodeURIComponent(value) })
};

function validaCNPJ(cnpj) {

    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj == '') return false;

    if (cnpj.length != 14)
        return false;

    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999")
        return false;

    // Valida DVs
   var tamanho = cnpj.length - 2
   var numeros = cnpj.substring(0, tamanho);
   var digitos = cnpj.substring(tamanho);
   var soma = 0;
   var pos = tamanho - 7;
    for (var i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0))
        return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
   var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1))
        return false;

    return true;

}

function validaCPF(cpf) {
    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf == '') return false;
    // Elimina CPFs invalidos conhecidos	
    if (cpf.length != 11 ||
        cpf == "00000000000" ||
        cpf == "11111111111" ||
        cpf == "22222222222" ||
        cpf == "33333333333" ||
        cpf == "44444444444" ||
        cpf == "55555555555" ||
        cpf == "66666666666" ||
        cpf == "77777777777" ||
        cpf == "88888888888" ||
        cpf == "99999999999")
        return false;
    // Valida 1o digito	
   var add = 0;
    for (var i = 0; i < 9; i++)
        add += parseInt(cpf.charAt(i)) * (10 - i);
  var  rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
        rev = 0;
    if (rev != parseInt(cpf.charAt(9)))
        return false;
    // Valida 2o digito	
    add = 0;
    for (i = 0; i < 10; i++)
        add += parseInt(cpf.charAt(i)) * (11 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
        rev = 0;
    if (rev != parseInt(cpf.charAt(10)))
        return false;
    return true;
}